<template>
  <FormSubmitPopup
    :title="$t('fillInAddressInformation')"
    v-model="value"
    :rightMethod="onSubmitted"
    @popupClose="$emit('input', false)"
    medium
  >
    <template v-slot:input>
      <v-flex md5>
        <v-text-field
          :label="$t('site_name')"
          id="Sitename"
          v-model="site.siteName"
          :disabled="editMode && !siteKeyCanEdit"
          :rules="[ fieldIsRequired('Site name'), checkDupSiteName ]"
          class="required_field"></v-text-field> 
      </v-flex>
      <v-text-field
        :label="$t('addressLine1')"
        id="Address"
        v-model="site.address1"
        :rules="[fieldIsRequired('Address')]"
        class="required_field"></v-text-field>
      <v-text-field
        :label="$t('addressLine2')"
        id="Address2"
        v-model="site.address2"
        ></v-text-field>
      <v-layout justify-space-between>
        <v-flex md3>
          <v-text-field
            :label="$t('city')"
            id="City"
            v-model="site.city"
            :rules="[fieldIsRequired('City')]"
            class="required_field"
            ></v-text-field>
        </v-flex>
        <v-flex md3>
          <v-autocomplete
            :items="states"
            v-model="site.state"
            :label="$t('state')"
            :disabled="editMode && !siteKeyCanEdit"
            id="addressState"
          >
            <template v-slot:item="data">
              <template>
                <v-list-tile-content>
                  <v-list-tile-title :id="data.item">
                    {{data.item}}
                  </v-list-tile-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex md3>
          <v-text-field
            :label="$t('zipCode')"
            id="Zip code"
            v-model="site.zip"
            :disabled="editMode && !siteKeyCanEdit"
            :rules="[fieldIsRequired('Zip code'), fieldIsZip('Zip code')]"
            class="required_field"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout justify-space-between>
        <v-flex md5>
          <v-text-field
            v-if="isWarehouse"
            :label="$t('contact')"
            id="Contact"
            v-model="site.contact"
            ></v-text-field>
        </v-flex>
        <v-flex md5>
          <v-text-field
            v-if="isWarehouse"
            :label="$t('phone')"
            id="Phone"
            v-model="site.phone"
            ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex md3>
          <v-switch
          v-model="site.stopReceive"
          :label="$t('stopReceive')"
          ></v-switch>
        </v-flex>
      </v-layout>
    </template>
  </FormSubmitPopup>
</template>

<script>
import FormSubmitPopup from './FormSubmitPopup'
import { checkRules } from '@/utils/tools'

export default {
  name: 'EditAddress',
  components: {
    FormSubmitPopup
  },
  mixins: [checkRules],
  data () {
    return {
      site: {
        siteName: '',
        address1: '',
        address2: '',
        state: '',
        city: '',
        zip: '',
        contact: '',
        phone: ''
      },
      siteKeyCanEdit: false
    }
  },
  mounted () {
    Object.assign(this.site, this.address)
    if (this.editMode) {
      this.checkDistribution()
        .then(checkResult => { this.siteKeyCanEdit = !checkResult })
    }
  },
  computed: {
    states () {
      return this.$store.getters.states
    },
    checkDupSiteName () {
      return (v) => !this.siteNames.has(v) || this.$t('validDuplicatedID')
    }
  },
  methods: {
    onSubmitted () {
      this.actionFunc(this.site, this.address)
    }
  },
  props: {
    value: Boolean,
    actionFunc: Function,
    isWarehouse: {
      type: Boolean,
      default: () => false
    },
    address: {
      type: Object,
      default: () => {}
    },
    editMode: {
      type: Boolean,
      default: () => false
    },
    siteNames: Set,
    checkDistribution: {
      type: Function,
      default: () => Promise.resolve()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EditAddress.vue